<div class="image-container--mobile">
  <img class="image--mobile" [src]="content?.fields.image.fields.file.url" loading="lazy" alt="" />
</div>

<div
  id="invite-your-friends"
  class="invite"
  [style.backgroundColor]="backgroundColor"
  [ngClass]="{ 'invite--smaller-image': smallerImage }"
>
  <div class="invite__inner-container">
    <div class="left-column">
      <h2 class="title">
        {{ content?.fields.title }}<br />
        <span class="some-name">{{ currentSomeChannel }}</span>
      </h2>
      <div class="ingress">
        {{ content?.fields.ingress }}
      </div>

      <div class="sharing" *ngIf="linkToShare$ | async as linkToShare">
        <app-share-link
          [linkToShare]="linkToShare"
          [title]="content?.fields.shareTitle"
          [mailBody]="content?.fields.shareToMailBody.content"
          [analyticsCategory]="'Click on invite'"
          [iconBackgroundColor]="iconBackgroundColor"
        >
        </app-share-link>
      </div>
    </div>

    <div class="right-column">
      <img class="image" [src]="content?.fields.image.fields.file.url" loading="lazy" alt="" />
    </div>
  </div>
</div>
